import {addToFavorites, removeFromFavorites} from '../infrastructure/productApi';
import {mapRemoteData} from '../../common/domain/RemoteData.model';

/**
 * @param {string} productCode
 * @param {boolean} isFavorite
 * @param {string|null} [actingAsNumCliente] - cliente por el que actúa el comercial
 * @returns {Promise<RemoteData<boolean>>}
 */
export const changeProductFavorite = async (productCode, isFavorite, actingAsNumCliente = null) => {
  let result;
  if (isFavorite) {
    result = await removeFromFavorites(productCode, actingAsNumCliente);
  } else {
    result = await addToFavorites(productCode, actingAsNumCliente);
  }
  return mapRemoteData(result, () => !isFavorite);
}
